import { useEffect, useRef, useState } from "react";
import { Facebook, CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "@/lib/api";

const inputCls = "w-full rounded-xl bg-surface glow-border px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-lime-400";

// Facebook profile link input with a live best-effort validity check (green ✓ / red ✕).
export default function FacebookLinkField({ value, onChange }) {
  const [fb, setFb] = useState({ status: "idle", reason: "" }); // idle|checking|valid|invalid
  const timer = useRef(null);
  const url = value || "";
  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);
    const u = (url || "").trim();
    if (!u) { setFb({ status: "idle", reason: "" }); return; }
    setFb({ status: "checking", reason: "" });
    timer.current = setTimeout(() => {
      api.post("/players/check-facebook", { url: u })
        .then(({ data }) => setFb({ status: data.valid ? "valid" : "invalid", reason: data.reason || "" }))
        .catch(() => setFb({ status: "invalid", reason: "Could not check link" }));
    }, 700);
    return () => timer.current && clearTimeout(timer.current);
  }, [url]);

  return (
    <div>
      <label className="text-xs uppercase font-bold tracking-wider" style={{ color: "var(--text-2)" }}>Facebook profile link</label>
      <div className="relative mt-1">
        <Facebook className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" style={{ color: "#3b82f6" }} />
        <input data-testid="pp-facebook" value={url} onChange={(e) => onChange(e.target.value)}
          placeholder="https://facebook.com/yourprofile" className={`${inputCls} pl-9 pr-10`} style={{ color: "var(--text)" }} />
        <span className="absolute right-3 top-1/2 -translate-y-1/2" data-testid="pp-facebook-status">
          {fb.status === "checking" && <Loader2 className="w-4 h-4 animate-spin" style={{ color: "var(--text-2)" }} />}
          {fb.status === "valid" && <CheckCircle2 className="w-5 h-5" style={{ color: "#22c55e" }} data-testid="pp-facebook-valid" />}
          {fb.status === "invalid" && <XCircle className="w-5 h-5" style={{ color: "#ef4444" }} data-testid="pp-facebook-invalid" />}
        </span>
      </div>
      {fb.status === "valid" && <p className="text-[11px] mt-1" style={{ color: "#22c55e" }}>Link is working — adds a verified badge once your email is confirmed too.</p>}
      {fb.status === "invalid" && <p className="text-[11px] mt-1" style={{ color: "#ef4444" }}>{fb.reason || "This link doesn't look valid."}</p>}
    </div>
  );
}
